import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_GETAPPLICATION_FULFILLED = "FETCH_GETAPPLICATION_FULFILLED";
export const FETCH_GETAPPLICATION_REJECTED = "FETCH_GETAPPLICATION_REJECTED";
export const FETCH_GETAPPLICATION_PENDING = "FETCH_GETAPPLICATION_PENDING";
export const RESET = "RESET"

export function getApplication(id) {
    const token = localStorage.getItem("accessToken")
    return (dispatch) => {
        dispatch({
            type: "FETCH_GETAPPLICATION",
            payload: axios({
                method: "get",
                url: `${API_BASE}/api/v2/second-opinion/details/` + id,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetGetApplication() {
    return (dispatch) => {
        dispatch({
            type: "RESET",
        });
    };
  }


